import {Pipe, PipeTransform} from '@angular/core';
import {Card} from '../../../_models/card.model';

@Pipe({name: 'chunk'})
export class ChunkPipe implements PipeTransform {
  transform(array: Card[], size: number) {
    let results: Card[][];
    results = [];
    while (array.length) {
      results.push(array.splice(0, size));
    }
    return results;
  }
}
